import React, { FC } from 'react';

import { Button, Grid, GridProps, Modal } from '@/shared/ui';

import { formatDate } from '@/helpers/dates';

import { WeaponMode, Weapon_v2 } from '@/api/types';

import { erzStatusName, erzTypeName } from '../../uk.l10n';

interface WeaponDetailsModalProps {
  selectedWeapon: Weapon_v2;
  handleModalClose: () => void;
}

const PLACEHOLDER = 'Немає інформації';

export const WeaponDetailsModal: FC<WeaponDetailsModalProps> = React.memo(({ selectedWeapon, handleModalClose }) => {
  let weaponData: GridProps['data'] = [];
  let weaponPartsData: Array<GridProps['data']> = [];

  switch (selectedWeapon.weaponType) {
    case 'cold_steel':
      weaponData = [
        ['Тип зброї', erzTypeName[selectedWeapon.weaponType]],
        ['Виробник', selectedWeapon.extra.weaponInfo.vendor],
        ['Вага (в грамах)', selectedWeapon.extra.weaponInfo?.weight],
        ['Дата останньої перевірки', formatDate(selectedWeapon.extra.weaponInfo.lastInspectionDate)],
        ['Місце зберігання зброї', selectedWeapon.extra.weaponInfo.addressStorage],
      ];
      break;
    case 'firearm':
      weaponData = [
        ['Статус', erzStatusName[selectedWeapon.statuses[0] as WeaponMode]],
        ['Категорія', selectedWeapon.extra.weaponInfo.category],
        ['Призначення', selectedWeapon.extra.weaponInfo.purpose],
        ['Виробник', selectedWeapon.extra.weaponInfo.vendor],
        ['Калібр', selectedWeapon.extra.weaponInfo.caliber],
        ['Кількість стволів', selectedWeapon.extra.weaponInfo.numberOfBarrels],
        ['Місце зберігання зброї', selectedWeapon.extra.weaponInfo.addressStorage],
        ['Дата останнього огляду (відстрілу)', formatDate(selectedWeapon.extra.weaponInfo.lastInspectionDate)],
        ['Загальна довжина (мм)', selectedWeapon.extra.weaponInfo.totalLength],
      ];
      if (selectedWeapon.parts) {
        weaponPartsData = selectedWeapon.parts.map((part) => [
          ['Тип частини зброї', part.type],
          ['Виробник', part.vendor],
          ['Серійний номер', part.serialNum],
        ]);
      }
      break;
    case 'firearm_part':
      weaponData = [
        ['Тип частини зброї', selectedWeapon.typeName],
        ['Серія та номер', selectedWeapon.serialNumber],
        ['Номер дозволу', selectedWeapon.permitNumber],
        ['Термін дії', formatDate(selectedWeapon.permitExpiredAt)],
      ];
      break;
    default:
      break;
  }

  return (
    <Modal
      size="lg"
      open={!!selectedWeapon}
      onCancel={handleModalClose}
      title={selectedWeapon.weaponType === 'firearm_part' ? undefined : selectedWeapon.model}
      footer={<Button onClick={handleModalClose}>Закрити</Button>}
      classNames={{
        content: 'weapon-detail',
        body: 'weapon-detail__modal-body',
        footer: 'weapon-detail__modal-footer',
        header: 'weapon-detail__modal-header',
      }}
    >
      <Grid title="Інформація про зброю" data={weaponData} placeholder={PLACEHOLDER} />
      {weaponPartsData.map((data) => (
        <Grid key={data[0][0]} title="Основні частини зброї" data={data} placeholder={PLACEHOLDER} />
      ))}
    </Modal>
  );
});
